// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__Vi0GA","menuButton":"styles_menuButton__9PPRi","appMenuToggled":"styles_appMenuToggled__EPzLG"};